"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _collectionInfo = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/collectionInfo"));
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
var filename = "collectioninfo";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedInfo, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (uid) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", false);
          case 2:
            _context.next = 4;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: "".concat(filename, "-").concat(uid)
            });
          case 4:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 11:
            _context.prev = 11;
            _context.next = 14;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: uid,
              lang: lang
            });
          case 14:
            response = _context.sent;
            mappedInfo = (0, _collectionInfo["default"])(response);
            _context.next = 18;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, "-").concat(uid, ".json"),
              result: mappedInfo
            });
          case 18:
            return _context.abrupt("return", mappedInfo);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](11);
            _context.next = 25;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 25:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 30;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 30:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - collection info uid: ".concat(uid, " - ").concat(_context.t0)));
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 21]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;